"use client";

import { cn } from "~/lib/utils";
import { ClientIcon } from "../ClientIcon";
import { MCP_CLIENTS, type McpClientId } from "../../lib/mcp-clients";

// // // //

/**
 * ClientSegmentedControl
 * Segmented control for picking an MCP client. Shared by the setup guide (to
 * switch the previewed instructions) and the connect wizard (to choose which
 * credential to create). Rendered as a radiogroup for accessibility.
 */
export function ClientSegmentedControl(props: {
    value: McpClientId;
    onValueChange: (client: McpClientId) => void;
    className?: string;
}) {
    const { value, onValueChange, className } = props;

    return (
        <div
            role="radiogroup"
            className={cn(
                "grid grid-cols-2 gap-1 rounded-md bg-muted p-1 sm:grid-cols-4",
                className,
            )}
        >
            {MCP_CLIENTS.map((client) => {
                const selected = client.id === value;
                return (
                    <button
                        key={client.id}
                        type="button"
                        role="radio"
                        aria-checked={selected}
                        onClick={() => onValueChange(client.id)}
                        className={cn(
                            "flex items-center justify-center gap-1.5 rounded-sm px-2 py-1.5 text-xs font-medium transition-colors",
                            "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
                            selected
                                ? "bg-background text-foreground shadow-sm"
                                : "text-muted-foreground hover:text-foreground",
                        )}
                    >
                        <ClientIcon
                            client={client.id}
                            className="size-3.5 shrink-0"
                        />
                        <span className="truncate">{client.label}</span>
                    </button>
                );
            })}
        </div>
    );
}
